import React, { useEffect } from 'react'
import {
    Box,
    Button,
    Card,
    CardHeader,
    Divider,
  } from '@mui/material';
import { Container, Item } from 'semantic-ui-react';
import useObtenerServiciosAcivos from '../../hooks/obtenerServiciosAcivos';
import { CircularProgress } from '@mui/material'

const Boxinfoservices = (props) => {
  //console.log(props.serviciosAct)
  const {serviciosActivos, serviciosContratados, loading, error} = useObtenerServiciosAcivos(props.serviciosAct)
  const [servicios,setservicios] = React.useState("")
  

  React.useEffect(()=>{

  },[serviciosContratados])
// console.log(loading)
// console.log(serviciosActivos)
// console.log(serviciosContratados)
  return (
    <Card className='typeMiniforms'>
    <CardHeader
      subheader="Tus servicios"
      title="Información"
    />
    <Divider />
    <Container className='formcontentmin' id="micuentafrominidash1">
    <span>Servicios: </span>

     {
      serviciosContratados?(<>
        {serviciosContratados.map((item) => ( <div key={item.id}><span> {item.name} </span></div>))}
        </>):(<>
                         {
                        loading?(<><CircularProgress /></>):(<>
                          {
                            error?(<>No contratados</>):(<>
                            2
                            </>)
                          }
                          
                          </>)
                         }
                          </>)  
    }
    


    </Container>
    <Divider />
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        p: 2
      }} >
      <Button
        color="primary"
        variant="contained" >
        Ver mas...
      </Button>
    </Box>
  </Card>
  )
}

export default Boxinfoservices